import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import RouterConstants from '@app/constants/router';
import colors from '@app/constants/colors';
import LanguageSwitch from './LanguageSwitch';

class NavMenu extends React.Component {
  navMenuRef = React.createRef();

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = (event) => {
    const { onClickHandler, burgerElement, isMenuOpen } = this.props;

    if (!isMenuOpen) return;

    const isNavigationElementClicked = this.navMenuRef.current.contains(event.target);
    const isMenuButtonClicked = burgerElement.contains(event.target);

    if (!isNavigationElementClicked && !isMenuButtonClicked) {
      onClickHandler(event);
    }
  }

  render() {
    const { onClickHandler, pathname, isMenuOpen } = this.props;
    return (
      <MobileMenu ref={this.navMenuRef} isMenuOpen={isMenuOpen}>
        <LinksList onClick={onClickHandler}>
          <li>
            <MobileMenuLink
              to={RouterConstants.HOME}
              actived={pathname === RouterConstants.HOME}
            >
              <FormattedMessage id="header.home" />
            </MobileMenuLink>
          </li>
          <li>
            <MobileMenuLink
              to={RouterConstants.ACCOUNT}
              actived={pathname === RouterConstants.ACCOUNT}
            >
              <FormattedMessage id="header.myAccount" />
            </MobileMenuLink>
          </li>
          <li>
            <MobileMenuLink
              to={RouterConstants.ACCOUNT_SUBSCRIPTION}
              actived={pathname === RouterConstants.ACCOUNT_SUBSCRIPTION}
            >
              <FormattedMessage id="header.mySubscription" />
            </MobileMenuLink>
          </li>
          <li>
            <MobileMenuLink
              to={RouterConstants.ACCOUNT_DEVICES}
              actived={pathname === RouterConstants.ACCOUNT_DEVICES}
            >
              <FormattedMessage id="header.myDevices" />
            </MobileMenuLink>
          </li>
        </LinksList>
        <SwitchWrapper>
          <LanguageSwitch isShowOnSmall />
        </SwitchWrapper>
      </MobileMenu>
    );
  }
}

NavMenu.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  burgerElement: PropTypes.element,
  isMenuOpen: PropTypes.bool.isRequired,
};

NavMenu.defaultProps = {
  burgerElement: null,
};

const mapStateToProps = ({ router: { location: { pathname } } }) => ({
  pathname,
});

export default withRouter(connect(mapStateToProps)(NavMenu));

const MobileMenu = styled.nav`
  display: none;
  background: #fff;
  box-shadow: 0 3px 5px 0 rgba(0,0,0,.1);
  left: 0;
  position: fixed;
  top: ${({ isMenuOpen }) => (isMenuOpen ? '74px' : ' -110px')};
  width: 270px;
  transition: .25s ease-in-out;
  @media (max-width: 979px) {
    display: block;
  }
  @media (max-width: 399px) {
    top: ${({ isMenuOpen }) => (isMenuOpen ? '74px' : ' -170px')};
  }
`;

const LinksList = styled.ul`
  list-style: none;
  margin: 19px 18px 10px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  & li {
    width: 100%;
  }
`;

const MobileMenuLink = styled(Link)`
  font-weight: ${({ actived }) => (actived ? 'bold' : 'normal')};
  color: ${colors.CERULEAN};
  font-size: 22px;
  text-decoration: none;
  width: 100%;
  display: block;
  text-align: right;
  padding: 6px 0;
  &:hover {
    text-decoration: underline;
  }
`;

const SwitchWrapper = styled.div`
  display: none;
  border-top: 1px solid #00abd1;
  padding: 15px 0;
  justify-content: center;
  @media (max-width: 399px) {
    display: flex;
    & div {
      display: flex;
    }
  }
`;
